import React from 'react';
import { ColorModeContext } from '../App/ThemeProvider';

// Higher-order component to provide theme context to class components
export const withTheme = (Component) => {
  return function WithThemeComponent(props) {
    // This is a function component, so we can use hooks here
    const themeContext = React.useContext(ColorModeContext);
    
    // Pass the theme context to the wrapped component as a prop
    return <Component {...props} themeMode={themeContext.mode} />;
  };
}; 